// Deriva la lista ordenada de claves de equipo (columnas) presentes en el
// dataset de inspección sectorizado.
export function equipmentKeysOf(sectors) {
  const list = Array.isArray(sectors) ? sectors : [];
  const seen = [];
  for (const sec of list) {
    for (const item of sec?.items || []) {
      for (const key of Object.keys(item?.cells || {})) {
        if (!seen.includes(key)) seen.push(key);
      }
    }
  }
  return seen;
}
